module.exports = __webpack_public_path__ + "img/create.fa20239c.svg";